export default __webpack_public_path__ + "static/media/next.851d87ec.svg";